/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ResourceTypeToSecurityGroup {
  /**
  * Security group to use for the restore server. If not specified, Eon attempts to use the default security group.  Currently, a single security group is supported. 
  */
  'restoreServer'?: Array<string>;
  /**
  * Security group to use for restored RDS instances. If not specified, Eon attempts to use the default security group.  Currently, a single security group is supported. 
  */
  'restoredRdsInstance'?: Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreServer",
      "baseName": "restoreServer",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "restoredRdsInstance",
      "baseName": "restoredRdsInstance",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ResourceTypeToSecurityGroup.attributeTypeMap;
  }

  public constructor() {
  }
}

